import React from"react";
import { useSelector, RootStateOrAny, useDispatch } from "react-redux";
import { Panel} from "office-ui-fabric-react";
import { useTranslation } from "react-i18next";
import { clear } from "../../../config/redux/orderTypes/orderTypesActions";
import {panelS} from "../../common/styles/panelStyles"
import TypeForm from "./TypeForm";
import { useOrderTypeForm } from "../hooks/useOrderTypeForm";

const OrderTypesPanel: React.FC = () => {
  const { t } = useTranslation("admin");
  const dispatch = useDispatch();
  const { editing } = useSelector(
    (state: RootStateOrAny) => state.orderTypes
  );

  const dissmisPanel = () => {
    dispatch(clear());
  };

  const {
    handleSubmit,
    initValues,
    cancelForm,
    selectedOrderTypes,
    loading,
  } = useOrderTypeForm();
  
  return (
    <Panel
      headerText={selectedOrderTypes[0] ? t("nav.panelOrderTypeEdit") as string : t("nav.panelOrderTypeAdd") as string}
      isOpen={editing}
      closeButtonAriaLabel={t("nav.close") as string}
      type={1}
      onDismiss={dissmisPanel}
      isLightDismiss={false}
      isHiddenOnDismiss={false}
      styles={panelS}
      isFooterAtBottom={true}
    >
      <TypeForm 
        handleSubmit={handleSubmit}
        initValues={initValues}
        cancelForm={cancelForm}
        selectedOrderTypes={selectedOrderTypes}
        loading={loading}
      />
    </Panel>
  );
};

export default OrderTypesPanel;
